// extracted by mini-css-extract-plugin
export var closeButton = "_17-3";
export var header = "_17-0";
export var link = "_17-1";
export var retryButton = "_17-2";